<template>
  <div class="feature">
    <div class="filter-head">
      <div class="type-select">
        <UserFeatureSingleSelect @transmit="getTypeSelectDate"></UserFeatureSingleSelect>
      </div>
      <div class="filter-box">
        <div class="date-select">
          <DateSelect @transmit="getSelectDate"></DateSelect>
        </div>
        <div class="extra-select stage-select">
          <UserFeatureSelect
            @transmit="getStageSelectItems"
            :selected-items="selectedStageList"
            :city-list="selectStageList"
          ></UserFeatureSelect>
        </div>
        <div class="extra-select location-select">
          <UserFeatureSelect
            @transmit="getProvinceSelectItems"
            :selected-items="selectedProvinceList"
            :city-list="selectProvinceList"
          ></UserFeatureSelect>
        </div>
        <div>
          <Button @click="getRangeData">确认</Button>
        </div>
      </div>
    </div>
    <div class="charts-box">
      <div class="user-stage" @click="selectShowTableBox(1)">
        <div class="chart-box">
          <div class="pie-chart">
            <UserFeaturePieECharts ref="pie_charts" :pie-data="pieData"></UserFeaturePieECharts>
          </div>
          <div class="line-chart">
            <UserFeatureLineECharts ref="stage_line_charts" :line-data="stageLineData"></UserFeatureLineECharts>
          </div>
        </div>
      </div>
      <div class="user-location" @click="selectShowTableBox(2)">
        <div class="chart-box">
          <div class="map-chart">
            <UserFeatureMapECharts ref="map_charts" :map-data="heatMapData"></UserFeatureMapECharts>
          </div>
          <div class="line-chart">
            <UserFeatureLineECharts ref="province_line_charts" :line-data="provinceLineData"></UserFeatureLineECharts>
          </div>
        </div>
      </div>
    </div>

    <div class="data-box">
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold">详细数据</span>
        </div>
        <div>
          <Button @click="exportData">导出</Button>
        </div>
      </div>
      <UserGetTable
        v-if="selectedShowTable===1"
        ref="child_table"
        :columns="stageTableData.columns"
        :ajax-data="stageTableData.data"
      ></UserGetTable>
      <UserGetTable
        v-else
        ref="child_table"
        :columns="provinceTableData.columns"
        :ajax-data="provinceTableData.data"
      ></UserGetTable>
    </div>
  </div>
</template>

<script>
import UserFeatureMapECharts from "../components/UserFeatureMapECharts";
import UserFeatureLineECharts from "../components/UserFeatureLineECharts";
import UserFeaturePieECharts from "../components/UserFeaturePieECharts";
import DateSelect from "../components/DateSelect";
import UserFeatureSelect from "../components/UserFeatureSelect";
import UserGetTable from "../components/UserGetTable";
import UserFeatureSingleSelect from "../components/UserFeatureSingleSelect";
import apis from "../http/api";

export default {
  name: "UserFeature",
  components: {
    UserFeatureMapECharts,
    UserFeatureLineECharts,
    UserFeaturePieECharts,
    DateSelect,
    UserFeatureSelect,
    UserGetTable,
    UserFeatureSingleSelect
  },
  data() {
    return {
      typeSelect: "new_add",                   // 图标纬度
      selectStageList: [
        { value: 'selectAll', label: '全选/清空' },
        { value: '小学生', label: '小学生' },
        { value: '初中生', label: '初中生' },
        { value: '高中生', label: '高中生' },
        { value: '大学生', label: '大学生' },
        { value: '研究生', label: '研究生' },
        { value: '博士', label: '博士' },
        { value: '上班族', label: '上班族' },
        { value: '自由中', label: '自由中' },
        { value: '保密', label: '保密' },
        { value: ' ', label: '未知' },
      ],                  // 可选阶段列表
      selectProvinceList: [
        { 'label': '全选/清空', 'value': 'selectAll' },
        { 'label': '黑龙江', 'value': '黑龙江省' },
        { 'label': '内蒙古', 'value': '内蒙古自治区' },
        { 'label': '山西', 'value': '山西省' },
        { 'label': '河北', 'value': '河北省' },
        { 'label': '辽宁', 'value': '辽宁省' },
        { 'label': '吉林', 'value': '吉林省' },
        { 'label': '江苏', 'value': '江苏省' },
        { 'label': '浙江', 'value': '浙江省' },
        { 'label': '安徽', 'value': '安徽省' },
        { 'label': '福建', 'value': '福建省' },
        { 'label': '江西', 'value': '江西省' },
        { 'label': '山东', 'value': '山东省' },
        { 'label': '河南', 'value': '河南省' },
        { 'label': '湖北', 'value': '湖北省' },
        { 'label': '湖南', 'value': '湖南省' },
        { 'label': '广东', 'value': '广东省' },
        { 'label': '海南', 'value': '海南省' },
        { 'label': '四川', 'value': '四川省' },
        { 'label': '贵州', 'value': '贵州省' },
        { 'label': '云南', 'value': '云南省' },
        { 'label': '陕西', 'value': '陕西省' },
        { 'label': '甘肃', 'value': '甘肃省' },
        { 'label': '青海', 'value': '青海省' },
        { 'label': '台湾', 'value': '中国台湾' },
        { 'label': '广西', 'value': '广西壮族自治区' },
        { 'label': '西藏', 'value': '西藏自治区' },
        { 'label': '宁夏', 'value': '宁夏回族自治区' },
        { 'label': '新疆', 'value': '新疆维吾尔自治区' },
        { 'label': '北京', 'value': '北京市' },
        { 'label': '天津', 'value': '天津市' },
        { 'label': '上海', 'value': '上海市' },
        { 'label': '重庆', 'value': '重庆市' },
        { 'label': '香港', 'value': '中国香港' },
        { 'label': '澳门', 'value': '中国澳门' },
        { 'label': '南海诸岛', 'value': '南海诸岛' },
        { 'label': '未知', 'value': ' ' }
      ],               // 可选省份列表

      selectedStageList: [
        '小学生',
        '初中生',
        '高中生',
        '大学生',
        '上班族'
      ],                // 已选阶段列表
      selectedProvinceList: [
        // '黑龙江省',
        // '山西省',
        '河北省',
        '辽宁省',
        // '吉林省',
        '江苏省',
        '浙江省',
        // '安徽省',
        // '福建省',
        // '江西省',
        '山东省',
        '河南省',
        '湖北省',
        // '湖南省',
        '广东省',
        // '海南省',
        '四川省',
        // '贵州省',
        // '云南省',
        // '陕西省',
        // '甘肃省',
        // '青海省',
        // '中国台湾',
        // '内蒙古自治区',
        // '广西壮族自治区',
        // '西藏自治区',
        // '宁夏回族自治区',
        // '新疆维吾尔自治区',
        '北京市',
        // '天津市',
        // '上海市',
        // '重庆市',
        // '中国香港',
        // '中国澳门',
        // '南海诸岛',
      ],             // 已选省份列表
      startSelectDate: null,                   // 阶段选择器开始时间
      endSelectDate: null,                     // 阶段选择器结束时间

      heatMapData: {},                        // 地图数据
      provinceLineData: {},                   // 省份折线图数据
      provinceTableData: {
        columns: [],
        data: []
      },                                      // 省份表格数据

      pieData: {},                            // 地图数据
      stageLineData: {},                      // 省份折线图数据
      stageTableData: {
        columns: [],
        data: []
      },                                      // 省份表格数据

      selectedShowTable: 1                    // 要展示的表格
    }
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - 1));
    this.startSelectDate = this.$moment(start).format("YYYY-MM-DD");
    this.endSelectDate = this.$moment(end).format("YYYY-MM-DD");
    this.getRangeData();
  },
  methods: {
    getRangeData() {
      try {
        this.$refs.pie_charts.loading();
        this.$refs.stage_line_charts.loading();
        this.$refs.map_charts.loading();
        this.$refs.province_line_charts.loading();
      } catch (e) {
        console.log('showLoading Error')
      }
      let post_data = {
        'start_date': this.startSelectDate,
        'end_date': this.endSelectDate,
        'province_list': this.selectedProvinceList,
        'stage_list': this.selectedStageList
      };
      if (this.typeSelect === 'new_add') {
        apis.user_feature_stage_range(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
            this.pieData = data.chart_data.pie_data;
            this.stageLineData = data.chart_data.line_data;
            this.stageTableData = data.table_data
          }
        }).catch();
        apis.user_feature_province_range(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
            this.heatMapData = data.chart_data.heat_map_data;
            this.provinceLineData = data.chart_data.line_data;
            this.provinceTableData = data.table_data
          }
        }).catch()
      } else if (this.typeSelect === 'active') {
        apis.user_feature_active_stage_range(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
            this.pieData = data.chart_data.pie_data;
            this.stageLineData = data.chart_data.line_data;
            this.stageTableData = data.table_data
          }
        }).catch();
        apis.user_feature_active_province_range(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
            this.heatMapData = data.chart_data.heat_map_data;
            this.provinceLineData = data.chart_data.line_data;
            this.provinceTableData = data.table_data
          }
        }).catch()
      } else if (this.typeSelect === 'consume') {
        apis.user_feature_consume_stage_range(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
            this.pieData = data.chart_data.pie_data;
            this.stageLineData = data.chart_data.line_data;
            this.stageTableData = data.table_data
          }
        }).catch();
        apis.user_feature_consume_province_range(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
            this.heatMapData = data.chart_data.heat_map_data;
            this.provinceLineData = data.chart_data.line_data;
            this.provinceTableData = data.table_data
          }
        }).catch()
      }

    },
    getTypeSelectDate(data) {
      this.typeSelect = data;
      this.getRangeData()
    },
    getSelectDate(data) {
      this.startSelectDate = this.$moment(data[0]).format("YYYY-MM-DD");
      this.endSelectDate = this.$moment(data[1]).format("YYYY-MM-DD");
    },
    getStageSelectItems(data) {
      this.selectedStageList = data
    },
    getProvinceSelectItems(data) {
      this.selectedProvinceList = data
    },
    exportData() {
      this.$refs.child_table.exportData()
    },
    selectShowTableBox(i) {
      this.selectedShowTable = i
    }
  }
}
</script>

<style scoped>
.feature {
  margin: 10px;
}

.filter-head {
  display: flex;
  padding: 5px 0 20px 0;
}

.charts-box {
  display: flex;
}

.user-stage,
.user-location {
  width: 50%;
}

.filter-box {
  display: flex;
  width: calc(100vw - 80px);
  justify-content: center;
  margin-right: 80px;
}

.chart-box {
  display: flex;
}

.map-chart {
  width: 40%;
  height: 300px;
}

.user-location .line-chart {
  width: 60%;
  height: 300px;
}

.user-stage .line-chart {
  width: 65%;
}

.pie-chart {
  width: 35%;
  height: 300px;
}

.data-box {
  margin-top: 50px;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}
</style>